webpackJsonp([273643807223514],{

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(35);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactTwitterWidgets = __webpack_require__(55);
	
	var _reactHelmet = __webpack_require__(27);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArticleIndexPage = function ArticleIndexPage(_ref) {
	  var pathContext = _ref.pathContext,
	      data = _ref.data;
	  var posts = pathContext.posts,
	      page = pathContext.page,
	      pagesSum = pathContext.pagesSum,
	      prevPath = pathContext.prevPath,
	      nextPath = pathContext.nextPath;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'container main-section' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Paul Kimbrel - Web Developer and Systems Architect, Sound Engineer.' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement('a', { name: 'top' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-8 level-one' },
	        posts.map(function (post, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: post.id },
	            _react2.default.createElement(
	              'article',
	              { className: 'synopsis' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: post.fields.slug },
	                _react2.default.createElement(
	                  'header',
	                  null,
	                  _react2.default.createElement(
	                    'h2',
	                    { className: 'withDate' },
	                    post.frontmatter.title
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'time',
	                      { dateTime: post.frontmatter.date },
	                      post.frontmatter.date
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'excerpt' },
	                post.excerpt
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: post.fields.slug },
	                'Read more...'
	              )
	            )
	          );
	        }),
	        nextPath && _react2.default.createElement(
	          'a',
	          { href: nextPath },
	          '\u2190 Older Posts'
	        ),
	        nextPath && prevPath && _react2.default.createElement(
	          'span',
	          null,
	          ' \u25CB '
	        ),
	        prevPath && _react2.default.createElement(
	          'a',
	          { href: prevPath },
	          'Newer Posts \u2192'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-4 level-two' },
	        _react2.default.createElement(_reactTwitterWidgets.Timeline, { dataSource: { sourceType: "profile", screenName: "pkimbrel" },
	          options: { username: "reactjs", height: "500" } })
	      )
	    )
	  );
	};
	
	exports.default = ArticleIndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-article-listing-js-2b7773374fd3b878284e.js